export type NestedMessages = {
  [key: string]: string | NestedMessages;
};

export type FlatMessages = Record<string, string>;

export function flattenMessages(
  source: NestedMessages,
  prefix = ''
): FlatMessages {
  return Object.entries(source).reduce<FlatMessages>((result, [key, value]) => {
    const id = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      result[id] = value;
    } else {
      Object.assign(result, flattenMessages(value, id));
    }

    return result;
  }, {});
}
